import * as Actions from 'reducks/staff/actions'
import { initialState } from 'reducks/reduxStore/initialState'

export const StaffReducer = (state = initialState.staff, action: any) => {
  switch (action.type) {
    case Actions.FETCH_STAFFS:
      return {
        ...state,
        staffs: [...action.payload],
      }
    case Actions.INIT_STAFFS:
      return {
        ...initialState.staff,
      }
    default:
      return state
  }
}
